import { ActionTree } from 'vuex'
import RootState from '@/store/RootState'
import TrackingState from "@/store/modules/tracking/ProjectState"

export const actions: ActionTree<TrackingState, RootState> = {
  setTracking ({ commit }, tracking) {
    commit('setTracking', tracking)
  }
}
